import { A } from '@adornis/base/env-info.js';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { Language } from '@adornis/translation-core/languages.js';
import { translations } from './translation.js';

export function seedClientTranslationDictionary(): void {
  if (A.isServer) return;

  // The first render must not see an empty dictionary; DB entries overlay this static baseline.
  clientTranslator.updateDictionary(translations, [Language.GERMAN, Language.ENGLISH]);
}
